import React from 'react';

import pluralize from 'pluralize';

import SelectAllCheckbox from './select_all_checkbox';

import { Button } from 'components/ui/button';

import type { Props } from './types';

export default function MapListHeaderEdgeCrm({
  toggleSelectAll,
  totalCount,
  totalLabel,
  ...props
}: Props) {
  return (
    <div className="d-flex gap-2 bg-white px-3 py-2 border-bottom align-items-center">
      <SelectAllCheckbox toggleSelectAll={toggleSelectAll} {...props} />
      <div className="flex-fill">
        <Button label="Select all" size="sm" variant="ghost" onClick={toggleSelectAll} />
      </div>
      <div className="fs-small">{pluralize(totalLabel, totalCount, true)}</div>
    </div>
  );
}
